import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';
class AccordionCustom extends HTMLElement {
  get details() {
    const details = this.querySelector('details');
    if (!(details instanceof HTMLDetailsElement))
      throw new Error('Details element not found');
    return details;
  }
  get summary() {
    const summary = this.details.querySelector('summary');
    if (!(summary instanceof HTMLElement))
      throw new Error('Summary element not found');
    return summary;
  }
  get #disableOnMobile() {
    return this.dataset.disableOnMobile === 'true';
  }
  get #disableOnDesktop() {
    return this.dataset.disableOnDesktop === 'true';
  }
  get #closeWithEscape() {
    return this.dataset.closeWithEscape === 'true';
  }
  #controller = new AbortController();
  connectedCallback() {
    const { signal: signal } = this.#controller;
    this.#setDefaultOpenState();
    this.addEventListener('keydown', this.#handleKeyDown, { signal: signal });
    this.summary.addEventListener('click', this.handleClick, {
      signal: signal,
    });
    this.details.addEventListener('click', this.#handleContentClick, {
      signal: signal,
    });
    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange, {
      signal: signal,
    });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  handleClick = (event) => {
    const isMobile = isMobileBreakpoint();
    const isDesktop = !isMobile;
    if (
      (isMobile && this.#disableOnMobile) ||
      (isDesktop && this.#disableOnDesktop)
    ) {
      event.preventDefault();
      return;
    }
  };
  #handleContentClick = (event) => {
    if (!this.details.open) return;
    if (!event.target.closest('[data-accordion-close]')) return;
    this.summary.focus({ preventScroll: true });
    this.details.open = false;
  };
  #handleMediaQueryChange = () => {
    this.#setDefaultOpenState();
  };
  #setDefaultOpenState() {
    const isMobile = isMobileBreakpoint();
    this.details.open =
      (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
      (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
  }
  #handleKeyDown(event) {
    if (event.key === 'Escape' && this.#closeWithEscape) {
      event.preventDefault();
      this.summary.focus();
      this.details.open = false;
    }
  }
}
if (!customElements.get('accordion-custom')) {
  customElements.define('accordion-custom', AccordionCustom);
}
